import { jsx as _jsx } from "react/jsx-runtime";
import { ResponsiveIcon } from 'console/shared/components/icon/responsive';
import SmokeIcon from '../icons/smoke.svg';
import SmokeAlarmIcon from '../icons/alarm-smoke.svg';
import MagnetIcon from '../icons/magnet.svg';
import MagnetAlarmIcon from '../icons/alarm-magnet.svg';
import MotionIcon from '../icons/motion.svg';
import MotionAlarmIcon from '../icons/alarm-motion.svg';
import LeakIcon from '../icons/leak.svg';
import LeakAlarmIcon from '../icons/alarm-leak.svg';
import GasIcon from '../icons/gas.svg';
import FailureIcon from '../icons/failure.svg';
import HumidityIcon from '../icons/humidity.svg';
import IgnitionIcon from '../icons/ignition.svg';
import RPMIcon from '../icons/rpm.svg';
import SpeedIcon from '../icons/speed.svg';
import AlarmButtonIcon from '../icons/alarm-button.svg';
import FuelStatIcon from '../icons/fuel-stat.svg';
import DiscreteIcon from '../icons/discrete.svg';
import ACIcon from '../icons/ac.svg';
import BatteryIcon from '../icons/battery.svg';
import ExtThermostat from '../icons/ext-term.svg';
import Thermometer from '../icons/thermostat.svg';
import { RelayIndicator } from 'shared/components/panels/heating-circuits/heating-circuit/components/status-line/components/icons/relay';
export function getIcons(icon, alarm) {
    if (icon == null) {
        return { icon: null };
    }
    switch (icon) {
        case 'smoke':
            return alarm
                ? {
                    icon: _jsx(ResponsiveIcon, { fontSize: "0.9em", Icon: SmokeAlarmIcon }),
                    label: 'Состояние',
                    trigger_value: 'обнаружен дым',
                }
                : {
                    icon: _jsx(ResponsiveIcon, { fontSize: "0.9em", Icon: SmokeIcon }),
                    label: 'Состояние',
                    trigger_value: 'отсутствие дыма',
                };
        case 'magnet':
            return alarm
                ? {
                    icon: _jsx(ResponsiveIcon, { fontSize: "0.9em", Icon: MagnetAlarmIcon }),
                    label: 'Состояние',
                    trigger_value: 'разомкнут',
                }
                : {
                    icon: _jsx(ResponsiveIcon, { fontSize: "0.9em", Icon: MagnetIcon }),
                    label: 'Состояние',
                    trigger_value: 'замкнут',
                };
        case 'motion':
            return alarm
                ? {
                    icon: _jsx(ResponsiveIcon, { fontSize: "0.9em", Icon: MotionAlarmIcon }),
                    label: 'Состояние',
                    trigger_value: 'движение обнаружено',
                }
                : {
                    icon: _jsx(ResponsiveIcon, { fontSize: "0.9em", Icon: MotionIcon }),
                    label: 'Состояние',
                    trigger_value: 'движения нет',
                };
        case 'leak':
            return alarm
                ? {
                    icon: (_jsx(ResponsiveIcon, { fontSize: "0.9em", viewBox: "0 0 20 20", Icon: LeakAlarmIcon })),
                    label: 'Состояние',
                    trigger_value: 'протечка',
                }
                : {
                    icon: (_jsx(ResponsiveIcon, { fontSize: "0.9em", viewBox: "0 0 20 20", Icon: LeakIcon })),
                    label: 'Состояние',
                    trigger_value: 'сухо',
                };
        case 'gas':
            return alarm
                ? {
                    icon: (_jsx(ResponsiveIcon, { fontSize: "0.9em", viewBox: "0 0 20 20", Icon: SmokeAlarmIcon })),
                    label: 'Состояние',
                    trigger_value: 'утечка газа',
                }
                : {
                    icon: (_jsx(ResponsiveIcon, { fontSize: "0.9em", viewBox: "0 0 20 20", Icon: GasIcon })),
                    label: 'Состояние',
                    trigger_value: 'утечки газа нет',
                };
        case 'thermostat':
            return {
                icon: (_jsx(ResponsiveIcon, { fontSize: "0.9em", viewBox: "0 0 20 20", Icon: ExtThermostat })),
                label: 'Термостат',
                trigger_value: '',
            };
        case 'failure':
            return {
                icon: _jsx(ResponsiveIcon, { fontSize: "0.9em", Icon: FailureIcon }),
                label: 'Ошибка',
            };
        case 'humidity':
            return { icon: _jsx(ResponsiveIcon, { Icon: HumidityIcon }), label: 'Влажность' };
        case 'ignition':
            return {
                icon: _jsx(ResponsiveIcon, { fontSize: "0.9em", Icon: IgnitionIcon }),
                label: 'Зажигание',
            };
        case 'speed':
            return { icon: _jsx(ResponsiveIcon, { Icon: SpeedIcon }), label: 'Скорость' };
        case 'rpm':
            return { icon: _jsx(ResponsiveIcon, { Icon: RPMIcon }), label: 'Обороты в минуту' };
        case 'alarm-button':
            return {
                icon: _jsx(ResponsiveIcon, { fontSize: "0.9em", Icon: AlarmButtonIcon }),
                label: 'Тревожная кнопка',
            };
        case 'fuel-stat':
            return { icon: _jsx(ResponsiveIcon, { Icon: FuelStatIcon }), label: 'Топлово' };
        case 'discrete':
            return { icon: _jsx(ResponsiveIcon, { Icon: DiscreteIcon }), label: 'Дискретный' };
        case 'ac':
            return {
                icon: _jsx(ResponsiveIcon, { viewBox: "0 0 32 32", Icon: ACIcon }),
                label: 'Напряжение',
            };
        case 'battery':
            return {
                icon: _jsx(ResponsiveIcon, { Icon: BatteryIcon }),
                label: 'Напряжение',
            };
        case 'temp':
            return {
                icon: (_jsx(ResponsiveIcon, { fontSize: "0.9em", viewBox: "0 0 20 20", Icon: Thermometer })),
                label: 'Температура',
                trigger_value: '',
            };
        case 'relay-no':
            return {
                icon: _jsx(RelayIndicator, {}),
                label: 'Дискретный вход нормально разомкнутый',
                trigger_value: 'Замкнут',
            };
        case 'relay-nc':
            return {
                icon: _jsx(RelayIndicator, { active: true }),
                label: 'Дискретный вход нормально замкнутый',
                trigger_value: 'Разомкнут',
            };
        default:
            return { icon: null };
    }
}
